import dirContent from './pt-br/index'
export default dirContent